import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthorizationService } from '../services/authorization.service';
import { Function, PermisstionId } from '../enums/authorization';

export const hasPermissionGuard: CanActivateFn = (route, state) => {
  const authorService = inject(AuthorizationService);
  let url = state.url.split('?')[0];

  let hasPermission;

    switch (url) {
      case '/':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_P_HOMEPAGE
        );
        break;
      case '/my-registration':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_P_HOMEPAGE
        );
        break;
      case '/profile':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_P_PROFILE
        );
        break;
      case '/profile/details':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_PROFILE
        );
        break;
      case '/profile/user-tt-update':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_PROFILE
        );
        break;
      case '/profile/user-lhl-update':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_PROFILE
        );
        break;
      case '/profile/change-password':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_CHANGEPASSWORD
        );
        break;
      case '/dashboard':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_P_DASHBOARD
        );
        break;
      case '/dashboard/clb':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_DASHBOARDTTCLB
        );
        break;
      case '/dashboard/khoi':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_DASHBOARDTTKHOI
        );
        break;
      case '/user-clbtt-mng':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBTUOITRE
        );
        break;
     case '/user-clbtt-mng/update':
      hasPermission = authorService.isAuthorizationByPerm(
        Function.A_C_MNCLBTUOITRE
      );
      break;       
      case '/user-clbtt-mng/add':
      hasPermission = authorService.isAuthorizationByPerm(
        Function.A_C_MNCLBTUOITRE
      );
      break;        
      case '/user-clbtt-khoi-mng':
      hasPermission = authorService.isAuthorizationByPerm(
        Function.A_C_MNCLBTUOITREKHOI
      );
      break;
     case '/user-clbtt-khoi-mng/update':
      hasPermission = authorService.isAuthorizationByPerm(
        Function.A_C_MNCLBTUOITREKHOI
      );
      break;       
      case '/user-clbtt-khoi-mng/add':
      hasPermission = authorService.isAuthorizationByPerm(
        Function.A_C_MNCLBTUOITREKHOI
      );
      break;  
      case '/sp-clb':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_SPCLBTTBLD
        );
        break;
      case '/sp-k':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_SPCLBTTKHOI
        );
        break;
       case '/ld-k':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBTUOITRELDKHOI
        );
        break;
       case '/ld-k/a':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBTUOITRELDKHOI, PermisstionId.PERM_CREATE
        );
        break;
       case '/ld-k/u':
        hasPermission = authorService.isAuthorizationByPerm(
          Function.A_C_MNCLBTUOITRELDKHOI, PermisstionId.PERM_EDIT
        );
        break;
      
    }
  
  if (hasPermission) {
    return true;
  }
  return false;
};
